enum EventType {
    /**
     * Szórakoztató (koncertek, FESZTIVÁLOK, disco).
     */
    ENTERTAINING = 'ENTERTAINING',

    /**
     * Családi (ESKÜVŐ, keresztelő, születésnap, ballagás, temetés).
     */
    FAMILY = 'FAMILY',

    /**
     * Tudományos (KONFERENCIA, kongresszus, vándorgyűlés).
     */
    SCIENTIFIC = 'SCIENTIFIC',

    /**
     * Komplex rendezvény (gyermekprogramok).
     */
    COMPLEX_EVENT = 'COMPLEX_EVENT',

    /**
     * Közösségi (klubdélutánok, szűk körű zártgyűlések).
     */
    COMMUNITY = 'COMMUNITY',

    /**
     * Kulturális (komolyzenei, népművészeti, kiállítások, irodalmi, színházi, amatőr alkotói...stb.).
     */
    CULTURAL = 'CULTURAL',

    /**
     * Politikai (gyűlések, tüntetések).
     */
    POLITICAL = 'POLITICAL',

    /**
     * Sajtótájékoztató.
     */
    NEWS_CONFERENCE = 'NEWS_CONFERENCE',

    /**
     * Sport (mérkőzések, versenyek, edzőtáborok).
     */
    SPORT = 'SPORT',

    /**
     * Társadalmi esemény (bál, gálavacsora, díszebéd, fogadás, operaházi gálaműsor).
     */
    SOCIAL_EVENT = 'SOCIAL_EVENT',

    /**
     * Üzleti (találkozók, üzleti reggelik, tréningek, csapatépítők, értekezletek, előadások, oktatások).
     */
    BUSINESS = 'BUSINESS',

    /**
     * Állami ünnep.
     */
    PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',

    /**
     * Egyházi / vallási ünnep.
     */
    CHURCH_HOLIDAY = 'CHURCH_HOLIDAY',

    /**
     * Egyik sem.
     */
    NONE = 'NONE',
}

export default EventType;
